var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[(_vm.loading)?_c('skeleton-loader',{attrs:{"type":"detail"}}):(_vm.routine)?[_c('routine-detail',{attrs:{"routine":_vm.routine,"program-mode":""},on:{"edit":_vm.openEditor}}),_c('program-routine-editor',{ref:"editor",on:{"success":_vm.onRoutineSaved}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }